export type BulkImportEntity = "employees" | "departments" | "teams" | "positions";

export function mapRow(entity: BulkImportEntity, row: Record<string, string>): Record<string, any> {
  const get = (k: string) => row[k.toLowerCase()] ?? "";
  if (entity === "employees") {
    return {
      name: get("name"), email: get("email"), jobTitle: get("jobtitle"), department: get("department"),
      phone: get("phone"), team: get("team"), location: get("location"), startDate: get("startdate"),
      contractType: get("contracttype"), birthday: get("birthday"), nationality: get("nationality"),
      address: get("address"), mainRole: get("mainrole"), subRole: get("subrole") || null,
      reportsToEmail: get("reportstoemail"),
      isLineManager: get("islinemanager"),
    };
  }
  if (entity === "departments") {
    return { name: get("name"), description: get("description"), headEmail: get("heademail") };
  }
  if (entity === "positions") {
    return { title: get("title"), description: get("description") };
  }
  return {
    teamName: get("teamname"),
    leaderEmail: get("leaderemail"),
    memberEmails: get("memberemails").split(";").map((s) => s.trim()).filter(Boolean),
  };
}
